<div class="relative">
  <!-- Bell Icon with Circle -->
  <button
    (click)="toggleDropdown(); $event.stopPropagation()"
    class="relative flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 shadow-sm transition"
    pTooltip="Notifications"
    tooltipPosition="top"
    aria-label="Notifications"
  >
    <svg
      class="w-5 h-5 text-gray-600 dark:text-gray-300"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
      />
    </svg>

    <!-- Unread Badge -->
    <span
      *ngIf="unreadCount > 0"
      class="absolute -top-1 -right-1 flex items-center justify-center min-w-[20px] h-[20px] px-1 text-[10px] font-bold text-white bg-brand-500 rounded-full leading-none ring-2 ring-white dark:ring-gray-900"
    >
      {{ unreadCount > 99 ? "99+" : unreadCount }}
    </span>
  </button>

  <!-- Dropdown Panel -->
  <div
    *ngIf="isOpen"
    (click)="$event.stopPropagation()"
    class="notification-panel absolute right-0 top-12 flex max-h-[500px] w-[420px] max-w-[calc(100vw-2rem)] flex-col rounded-2xl shadow-theme-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 z-[9999] overflow-hidden"
  >
    <div class="notification-gradient-line shrink-0"></div>

    <!-- Header -->
    <div class="px-4 py-2.5 border-b border-gray-200 dark:border-gray-700 shrink-0">
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-2.5">
          <h3 class="text-sm font-bold text-gray-800 dark:text-white">
            Notifications
          </h3>
          <span
            class="text-[11px] font-bold px-2 py-0.5 rounded-full"
            [ngClass]="{
              'text-white bg-brand-500': unreadCount > 0,
              'text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800':
                unreadCount === 0,
            }"
          >
            {{ unreadCount }} new
          </span>
        </div>
        <div class="flex items-center gap-1.5">
          <button
            (click)="markAllRead()"
            [disabled]="unreadCount === 0 || markingAllRead"
            pTooltip="Mark all read"
            tooltipPosition="top"
            aria-label="Mark all read"
            class="flex items-center justify-center w-8 h-8 rounded-lg text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 disabled:opacity-30 disabled:cursor-not-allowed transition"
          >
            <i class="pi pi-list-check text-sm"></i>
          </button>
          <button
            (click)="deleteAllNotifications()"
            [disabled]="!NotificationList?.length"
            pTooltip="Delete all"
            tooltipPosition="top"
            aria-label="Delete all"
            class="flex items-center justify-center w-8 h-8 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-red-50 hover:text-red-500 dark:hover:bg-red-500/10 dark:hover:text-red-400 disabled:opacity-30 disabled:cursor-not-allowed transition"
          >
            <i class="pi pi-trash text-sm"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Notification List -->
    <div
      class="min-h-0 flex-1 overflow-y-auto divide-y divide-gray-100 dark:divide-gray-800"
    >
      <ng-container *ngIf="NotificationList?.length; else emptyState">
        <div
          *ngFor="let item of NotificationList; let i = index"
          (click)="itemNotificationClicked($event, item, i)"
          class="group flex items-start gap-2.5 px-4 py-2.5 transition-colors hover:bg-gray-50 dark:hover:bg-white/5"
          [ngClass]="{
            'bg-brand-50/50 dark:bg-brand-500/[0.06]': !item.is_read,
            'cursor-pointer': canNavigate(item),
          }"
        >
          <!-- Module icon -->
          <span
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg"
            [ngClass]="{
              'bg-brand-50 text-brand-600 dark:bg-brand-500/10 dark:text-brand-400': !item.is_read,
              'bg-gray-100 text-gray-400 dark:bg-white/5 dark:text-gray-500': item.is_read,
            }"
            aria-hidden="true"
          >
            <i class="pi text-sm" [ngClass]="getModuleIcon(item.module_id)"></i>
          </span>

          <!-- Content -->
          <div class="flex-1 min-w-0">
            <!-- Message -->
            <p
              class="text-[12.5px] leading-snug break-words"
              [ngClass]="{
                'font-semibold text-gray-900 dark:text-white': !item.is_read,
                'font-normal text-gray-500 dark:text-gray-400': item.is_read,
              }"
            >
              {{ item.message }}
            </p>
            <!-- Module Name as Sub-header for Export -->
            <span
              *ngIf="item.reference_id === 0 || item.reference_id === '0'"
              class="inline-block text-[10px] font-semibold uppercase tracking-wider text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-500/10 px-2 py-0.5 rounded mb-1"
            >
              {{ getModuleName(item.module_id) }}
            </span>
            <!-- Time -->
            <div class="flex items-center gap-1 mt-1">
              <div
                class="flex items-center gap-1"
                [title]="formatNotificationDate(item.created_on)"
              >
                <i
                  class="pi pi-clock text-[10px] text-gray-400 dark:text-gray-500"
                ></i>
                <span class="text-[11px] text-gray-400 dark:text-gray-500">
                  {{ getTimeAgo(item.created_on) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Delete Button (revealed on hover) -->
          <button
            (click)="deleteNotification(item, i, $event)"
            class="shrink-0 mt-0.5 w-6 h-6 flex items-center justify-center rounded-full text-gray-400 dark:text-gray-500 hover:bg-red-50 hover:text-red-500 dark:hover:bg-red-500/10 dark:hover:text-red-400 transition-all md:opacity-0 md:group-hover:opacity-100 md:group-focus-within:opacity-100 focus:opacity-100"
            pTooltip="Delete"
            tooltipPosition="top"
            aria-label="Delete notification"
          >
            <i class="pi pi-trash text-[11px]"></i>
          </button>
        </div>
      </ng-container>

      <!-- Empty State -->
      <ng-template #emptyState>
        <div class="flex flex-col items-center justify-center px-6 py-12 text-center">
          <span class="flex items-center justify-center w-14 h-14 rounded-full bg-brand-50 dark:bg-brand-500/10">
            <i class="pi pi-bell text-2xl text-brand-500"></i>
          </span>
          <p class="text-sm font-semibold text-gray-800 dark:text-white mt-4">
            You're all caught up
          </p>
          <p class="text-[13px] text-gray-400 dark:text-gray-500 mt-1">
            New updates from your team will appear here.
          </p>
        </div>
      </ng-template>
    </div>

    <!-- Footer -->
    <div class="px-4 py-2.5 border-t border-gray-200 dark:border-gray-700 bg-gray-50/70 dark:bg-gray-800/40 shrink-0">
      <button
        (click)="showAll()"
        class="flex w-full items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-[12px] font-semibold text-brand-600 dark:text-brand-400 bg-brand-50 hover:bg-brand-100/70 dark:bg-brand-500/10 dark:hover:bg-brand-500/20 transition cursor-pointer"
      >
        View all notifications
        <i class="pi pi-arrow-right text-[11px]"></i>
      </button>
    </div>
  </div>
  <p-confirmDialog key="notification-bell" [draggable]="false" />
</div>
